import { useCurrentUserSuspenseQuery } from "@/api/queries/useCurrentUserSuspenseQuery"
import {
  correspondenceQueryKeys,
  CorrespondenceThreadRoute,
} from "toptaal-shared"
import { createFileRoute, useParams, useRouter } from "@tanstack/react-router"
import { CorrespondenceEntityType } from "toptaal-shared"
import { checkPermissions } from "@/utils/checkPermissions"
import { can } from "@/utils/can"

export const Route = createFileRoute(
  "/beheer/contracten/$contractId/correspondentie/$threadId",
)({
  component: RouteComponent,
  beforeLoad: async () => {
    return checkPermissions("read", "projectCorrespondence")
  },
})

function RouteComponent() {
  const router = useRouter()
  const { data: user } = useCurrentUserSuspenseQuery()
  const { contractId: contractIdParam, threadId: threadIdParam } = useParams({
    from: "/beheer/contracten/$contractId/correspondentie/$threadId",
  })

  const entityType: CorrespondenceEntityType = "Project"
  const threadId = Number(threadIdParam)
  const entityId = Number(contractIdParam)

  const handleNavigateBack = () => {
    router.navigate({
      to: `/beheer/contracten/${contractIdParam}/correspondentie`,
    })
  }

  return (
    <CorrespondenceThreadRoute
      threadId={threadId}
      entityType={entityType}
      entityId={entityId}
      user={user.data}
      correspondenceQueryKeys={correspondenceQueryKeys}
      onNavigateBack={handleNavigateBack}
      canCreateCorrespondence={can("create", "projectCorrespondence")}
    />
  )
}
